const PRICE_LIST_SEIKATSU_MEDICAL = {
  ID: "seikatsu-medical",
  PRICE_M: [
    { AGE: 0, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 1, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 2, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 3, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 4, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 5, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 6, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 7, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 8, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 9, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 10, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 11, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 12, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 13, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 14, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 15, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 16, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 17, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 18, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 19, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 20, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 21, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 22, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 23, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 24, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 25, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 26, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 27, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 28, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 29, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 30, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 31, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 32, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 33, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 34, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 35, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 36, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 37, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 38, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 39, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    {
      AGE: 40,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 41,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 42,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 43,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 44,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 45,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 46,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 47,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 48,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 49,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 50,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 51,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 52,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 53,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 54,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 55,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 56,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 57,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 58,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 59,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 60,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 61,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 62,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 63,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 64,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 65,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 66,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 67,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 68,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 69,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 70,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 71,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 72,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 73,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 74,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 75,
      1: 7650,
      2: 6650,
      3: 5330,
      4: 4330,
      5: 10690,
      6: 9690,
      7: 8370,
      8: 7370,
    },
  ],
  PRICE_F: [
    { AGE: 0, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 1, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 2, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 3, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 4, 1: 400, 2: 380, 3: 380, 4: 360, 5: 460, 6: 440, 7: 440, 8: 420 },
    { AGE: 5, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 6, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 7, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 8, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 9, 1: 310, 2: 290, 3: 290, 4: 270, 5: 370, 6: 350, 7: 350, 8: 330 },
    { AGE: 10, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 11, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 12, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 13, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 14, 1: 290, 2: 270, 3: 270, 4: 250, 5: 350, 6: 330, 7: 330, 8: 310 },
    { AGE: 15, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 16, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 17, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 18, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 19, 1: 330, 2: 310, 3: 300, 4: 280, 5: 420, 6: 400, 7: 390, 8: 370 },
    { AGE: 20, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 21, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 22, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 23, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 24, 1: 450, 2: 420, 3: 420, 4: 390, 5: 640, 6: 610, 7: 610, 8: 580 },
    { AGE: 25, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 26, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 27, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 28, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 29, 1: 510, 2: 470, 3: 460, 4: 420, 5: 810, 6: 770, 7: 760, 8: 720 },
    { AGE: 30, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 31, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 32, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 33, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 34, 1: 560, 2: 520, 3: 480, 4: 440, 5: 910, 6: 870, 7: 830, 8: 790 },
    { AGE: 35, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 36, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 37, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 38, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    { AGE: 39, 1: 640, 2: 590, 3: 530, 4: 480, 5: 940, 6: 890, 7: 830, 8: 780 },
    {
      AGE: 40,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 41,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 42,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 43,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 44,
      1: 740,
      2: 680,
      3: 590,
      4: 530,
      5: 1040,
      6: 980,
      7: 890,
      8: 830,
    },
    {
      AGE: 45,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 46,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 47,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 48,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 49,
      1: 1020,
      2: 940,
      3: 780,
      4: 700,
      5: 1400,
      6: 1320,
      7: 1160,
      8: 1080,
    },
    {
      AGE: 50,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 51,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 52,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 53,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 54,
      1: 1380,
      2: 1270,
      3: 1020,
      4: 910,
      5: 1870,
      6: 1760,
      7: 1510,
      8: 1400,
    },
    {
      AGE: 55,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 56,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 57,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 58,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 59,
      1: 2050,
      2: 1870,
      3: 1460,
      4: 1280,
      5: 2720,
      6: 2540,
      7: 2130,
      8: 1950,
    },
    {
      AGE: 60,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 61,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 62,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 63,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 64,
      1: 2980,
      2: 2710,
      3: 2110,
      4: 1840,
      5: 3890,
      6: 3620,
      7: 3020,
      8: 2750,
    },
    {
      AGE: 65,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 66,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 67,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 68,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 69,
      1: 4210,
      2: 3790,
      3: 2920,
      4: 2500,
      5: 5530,
      6: 5110,
      7: 4240,
      8: 3820,
    },
    {
      AGE: 70,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 71,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 72,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 73,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 74,
      1: 5990,
      2: 5240,
      3: 4180,
      4: 3430,
      5: 8090,
      6: 7340,
      7: 6280,
      8: 5530,
    },
    {
      AGE: 75,
      1: 7650,
      2: 6650,
      3: 5330,
      4: 4330,
      5: 10690,
      6: 9690,
      7: 8370,
      8: 7370,
    },
  ],
};
export { PRICE_LIST_SEIKATSU_MEDICAL };
